import { render, staticRenderFns } from "./AscDocMgmtContentEditorWrapper.vue?vue&type=template&id=4948c4c7&"
import script from "./AscDocMgmtContentEditorWrapper.vue?vue&type=script&lang=js&"
export * from "./AscDocMgmtContentEditorWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports